export default "__VITE_ASSET__Ceqm$cXe__"